<template>
    <div
        class="fixed z-40 h-[72px] w-full border-b border-gray-850 bg-gray-900 lg:static"
    >
        <div
            class="container-fluid flex select-none justify-between gap-4 px-6 py-4"
        >
            <div class="hidden flex-none items-center lg:flex">
                <Link href="/">
                    <img
                        src="/assets/art/logos/emtprep_logo_ondark@2x.png"
                        class="h-[39px] w-[115px]"
                    />
                </Link>
            </div>
            <div class="mx-2 hidden border-l border-white/20 lg:inline"></div>
            <div class="hidden flex-none items-center lg:flex">
                <img :src="group.avatar" class="h-[39px] rounded rounded-md" />
            </div>
            <div class="hidden items-center lg:flex">
                <dropdown open-from="left" :px-width="240">
                    <template #button>
                        <div
                            class="group flex items-center gap-2 text-white hover:cursor-pointer"
                        >
                            <div class="">
                                {{ group.name }}
                            </div>
                            <div class="opacity-50 group-hover:opacity-100">
                                <svg
                                    width="12"
                                    height="6"
                                    viewBox="0 0 12 6"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.5 0.75L6 5.25L10.5 0.75"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #content>
                        <ul class="m-4 flex flex-col gap-4">
                            <li>
                                <Link
                                    class="w-full p-4"
                                    :href="route('group.settings')"
                                    >Settings
                                </Link>
                            </li>
                            <li>
                                <Link
                                    class="w-full p-4"
                                    :href="route('group.payment-history')"
                                    >Payment History
                                </Link>
                            </li>
                        </ul>
                    </template>
                </dropdown>
            </div>
            <div class="hidden flex-grow lg:flex"></div>
            <div class="">
                <div class="group flex items-center gap-2 text-white">
                    <dropdown open-from="right" :px-width="300">
                        <template #button>
                            <div class="flex items-center gap-2">
                                <div class="">
                                    <UserAvatarRound
                                        :user="$page.props.auth.user"
                                        size="44"
                                    />
                                </div>
                                <div class="">
                                    {{ $page.props.auth.user.full_name }}
                                </div>
                                <div class="opacity-50 group-hover:opacity-100">
                                    <svg
                                        width="12"
                                        height="6"
                                        viewBox="0 0 12 6"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.5 0.75L6 5.25L10.5 0.75"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </template>
                        <template #content>
                            <ul class="m-4 flex flex-col gap-4">
                                <li>
                                    <Link
                                        class="w-full p-4"
                                        :href="
                                            route('group.admin.show', {
                                                user: $page.props.auth.user.id,
                                            })
                                        "
                                        >My Profile
                                    </Link>
                                </li>
                                <li>
                                    <a
                                        class="w-full p-4"
                                        :href="route('logout')"
                                        >Log Out
                                    </a>
                                </li>
                            </ul>
                        </template>
                    </dropdown>
                </div>
            </div>
            <div class="flex items-center lg:hidden">
                <slide-over-menu open-from="right">
                    <template #trigger>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 6C1 5.44772 1.44772 5 2 5H22C22.5523 5 23 5.44772 23 6C23 6.55228 22.5523 7 22 7H2C1.44772 7 1 6.55228 1 6Z"
                                fill="#E1E5E8"
                            />
                            <path
                                d="M1 12C1 11.4477 1.44772 11 2 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12Z"
                                fill="#E1E5E8"
                            />
                            <path
                                d="M1 18C1 17.4477 1.44772 17 2 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H2C1.44772 19 1 18.5523 1 18Z"
                                fill="#E1E5E8"
                            />
                        </svg>
                    </template>
                    <template #menu_content>
                        <div class="flex h-full max-h-[700px] flex-col">
                            <div class="flex border-b border-gray-100 p-4">
                                <Link href="/">
                                    <img
                                        src="/assets/art/logos/emtprep_logo_color@2x.png"
                                        class="h-[28px] w-[80px]"
                                    />
                                </Link>
                            </div>
                            <ul class="flex w-full flex-col p-4">
                                <Link
                                    as="li"
                                    v-for="item in menuItems"
                                    :href="route(item.link)"
                                    class="flex h-full w-full flex-col border-b border-gray-100 px-2 py-4 hover:cursor-pointer"
                                >
                                    <span>{{ item.name }}</span>
                                </Link>
                            </ul>
                            <div class="flex-grow"></div>
                            <div
                                class="flex-none p-4 text-[12px] text-gray-700"
                            >
                                {{ group.name }}
                            </div>
                            <div class="flex flex-col gap-3 p-4">
                                <ul class="flex flex-col gap-4">
                                    <li>
                                        <Link :href="route('group.settings')"
                                            >Settings
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            :href="
                                                route('group.payment-history')
                                            "
                                            >Payment History
                                        </Link>
                                    </li>
                                    <li>
                                        <a :href="route('logout')">Log Out </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </template>
                </slide-over-menu>
            </div>
        </div>
    </div>
    <div class="pt-[72px] lg:pt-0"></div>
</template>

<script>
import SlideOverMenu from "@/Components/SlideOverMenu";
import Dropdown from "@/Components/Dropdown";
import UserAvatarRound from "@/Components/UserAvatarRound";

export default {
    name: "GroupHeader",
    components: { Dropdown, SlideOverMenu, UserAvatarRound },
    data() {
        return {
            group: this.$page.props.group,
            menuItems: this.$page.props.menuItems,
        };
    },
    methods: {},
};
</script>
